module.exports = {
    "customerId":"",
    "skill":"WebChat Xpressdocs", //"WebChat Visa" for visa company
    "first_name":"Elli", // logged in agent first name
    "last_name":"Keener", //logged in agent last name
    // "holidayMessage": "Hello and thank you for shopping with us! At this\n        time, there are no agents available to chat, but your business is important to us! Our Client\n        Services Department business hours are 8 a.m. to 6 p.m. CST Monday-Friday. Please contact us\n        during normal business hours via Live Chat, phone (866-977-3627) or email (info@xpressdocs.com).\n        We look forward to assisting you!", //Holiday Message
    "addressStreet":"",
    "addressCity":"",
    "addressPostalCode":"",
    "addressState":"",
    "phoneNumber":"",
    "customField1Label":"Company ID", // "Without login chat"
    "customField1": "XD Company, 134PUBLIC",  // emtpy for not logged in session
    "customField2Label":"Order ID",
    "customField2":"", //populate order id if exists
    "chatEnabled": true,
};